const MIN_WIDTH = 400
const MIN_HEIGHT = 80
const MAX_ASPECT = 6
const MAX_BYTES = 2 * 1024 * 1024

export const COMPANY_LOGO_HINT =
  'Header logo. PNG or JPG, wider than it is tall, at least 400×80px, and under 2MB.'

const readImageSize = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => {
    const size = { width: img.naturalWidth, height: img.naturalHeight }
    URL.revokeObjectURL(url)
    resolve(size)
  }
  img.onerror = () => {
    URL.revokeObjectURL(url)
    reject(new Error('unreadable'))
  }
  img.src = url
})

const isPngOrJpg = (file) => {
  const type = String(file.type || '').toLowerCase()
  const name = String(file.name || '').toLowerCase()
  return type === 'image/png'
    || type === 'image/jpeg'
    || name.endsWith('.png')
    || name.endsWith('.jpg')
    || name.endsWith('.jpeg')
}

/** Returns an error message, or null when the file can be used as a header logo. */
export async function companyLogoError(file) {
  if (!file) return 'Choose a logo image.'
  if (!isPngOrJpg(file)) return 'Logo must be a PNG or JPG file.'
  if (file.size > MAX_BYTES) return 'Logo must be less than 2MB.'

  let size
  try {
    size = await readImageSize(file)
  } catch {
    return 'Could not read that logo. Choose a PNG or JPG file.'
  }

  const { width, height } = size
  if (width < MIN_WIDTH || height < MIN_HEIGHT) {
    return `Logo must be at least ${MIN_WIDTH}px wide and ${MIN_HEIGHT}px tall. This file is ${width}×${height}px.`
  }
  if (width <= height) {
    return 'Logo must be horizontal, wider than it is tall, so it fits the header.'
  }
  if (width / height > MAX_ASPECT) {
    return 'Logo is too wide for the header. Keep the width within 6 times the height.'
  }
  return null
}
